import { stringify } from 'querystring';
import { AfterViewInit, Component, DebugElement, ElementRef, OnInit, Output, ViewChild, } from '@angular/core';
//import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from 'src/app/services/common.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import { AdvanceGridviewComponent } from 'src/app/shared/components/advance-gridview/advance-gridview.component';
import { FormControl, FormGroup } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { config } from 'process';
import configura from '../../../assets/config.json';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, AfterViewInit {

  lstProcessData: any[] = [];
  lstProcessQueue: any[] = [];
  lstDocumentQueue = [];

  lstStatDropProcess = { documentList: [] };
  lstStatDropDocument = { processList: [] };

  lstTransaction: any[] = [];
  lstTransaction_download: any[] = [];

  lstHeaders = [];
  lstHeaders_log = [];
  lstTransaction_search: any[] = [];
  lstHeader_search: any[] = [];

  ProcessList = [];

  frmFilterSearch: FormGroup;

  searchURN: string = '';
  advanceSearchSummaryFields: any = [];
  advanceSearchFilterFields: any = [];

  advanceSearchSummaryStaticFields: any = {
    URN: "",
    Priority: "",
    SOURCE: "",
    FROM_EMAIL: "",
    Created_Dt_From: "",
    Created_Dt_To: ""
  };

  //advanceSearchFilterFieldsData = {};

  isDisplayTransactionData = false;
  isDisplaySearchBox = false;
  isDisplaySearchGrid = false;
  showAllBx: boolean = false;
  showStatDrop: boolean = false;
  flipProcess = false;

  lstWorkListFilter: any = [];
  selectedWorklistId: number = 0;
  lstDocumentTypeFilter: any = [];
  filteredDoctypes: any = [];
  filteredQueue = [];

  maxideageneratedby: number = 0;
  totalidea: number = 0;
  total_idea_for_month: number = 0;
  ideathon_winnerfor_month: string = '';
  max_idead_generated_by_documenttype: string = '';
  winning_idea: string = '';

  activeProcess: number = 0;
  processName: string = '';
  activeDocument: number = 0;
  selectedDocument: string = '';
  viewType: string = 'TABULAR';
  sortColumnInfo = { name: '', isOrderAsc: true };

  selectedCellIndex: number = -1;
  selectedRowIndex: number = -1;
  saveAsDefaultFilter: boolean = false;
  currentPage: any = 1;
  recordsperPage: any = 50;
  countStickyGridWidth: number = 200;
  approvalQueryCount: number = 1;

  txtURN: string = '';
  txtInputFrom: string = '';
  txtInputType: string = '';
  ddlPriority: string = '';
  isDateRangeHasValue = false;
  maxDate = new Date();

  invoiceCreationDateRange = new FormGroup({
    start_date: new FormControl(),
    end_date: new FormControl(),
  });

  isOpenAdvanceSearch: boolean = false;

  lstPriority: any = [
    { value: '', text: 'All' },
    { value: 'NORMAL', text: 'Normal' },
    { value: 'HiGH', text: 'High' },
  ]

  @ViewChild('processData') processData: ElementRef;
  @ViewChild('stateDrop') stateDrop: ElementRef;
  @ViewChild('page_section') public pageSection: ElementRef;
  @ViewChild('summary_grid') public summaryGrid: ElementRef;
  @ViewChild('selectedCountTd') selectedCountTd: ElementRef<HTMLElement>;
  @ViewChild('countStickyTable') countStickyTable: ElementRef<HTMLElement>;
  @ViewChild('gridTransactionData') gridTransactionData: AdvanceGridviewComponent;
  @ViewChild('filterOptionModal') filterOptionModal: ElementRef;

  modalReference: any;
  currentdoc: any;
  currentprocess: any;
  backflag: boolean;
  pageflag: boolean = true;

  constructor(private dataService: DataService, public commonService: CommonService,private memorystore: MemoryStorageService,
    private route: Router, private modalService: NgbModal, private encryptDecryptservice: EncryptDecryptService) {

    if (route.getCurrentNavigation().extras.state != undefined) {
      this.backflag = true;
      //this.invoiceOpenFromPage = route.getCurrentNavigation().extras.state.sourcePage;
    }
    //wowService.init();
  }

  async ngOnInit(): Promise<void> {
    // this.isOpenAdvanceSearch = JSON.parse(this.commonService.getUserInfoFromLocalStorage('isOpenAdvanceSearch'));
    this.isOpenAdvanceSearch = JSON.parse(this.memorystore.getItem('isOpenAdvanceSearch'));
    await this.getProcessList();
    await this.getDocumentTypes();

    await this.onPageLoadFilterHistory()
    //await this.onSelectFilterQueue(0);
    await this.getDashboardFilter();

    //  if(configura.is_Display_maxPIideageneratedByUser=="TRUE")                    
    //  {
    //    await this.maxideageneratedbyUser();
    //  }


    if (this.filteredDoctypes == undefined || this.filteredDoctypes.length == 0) {
      await this.onSelectFilterDocument(0);
    }

    this.approvalQueryCount = 0  ///added to comment the below line as suggested by Arun
    //this.getApprovalQueryCount();
    await this.getProcessData();
  }

  ngAfterViewInit() {
    // this.activeDocument = this.commonService.getUserInfoFromLocalStorage('dash_docTypeId');
    // this.activeProcess = this.commonService.getUserInfoFromLocalStorage('dash_processId');
    // this.currentPage = this.commonService.getUserInfoFromLocalStorage("transactionSummary_CurrentPage");
    // this.recordsperPage = this.commonService.getUserInfoFromLocalStorage("transactionSummary_RecordsPerPage");
    this.activeDocument = this.memorystore.getItem('dash_docTypeId');
    this.activeProcess = this.memorystore.getItem('dash_processId');
    this.currentPage = this.memorystore.getItem("transactionSummary_CurrentPage");
    this.recordsperPage = this.memorystore.getItem("transactionSummary_RecordsPerPage");
    this.currentPage = this.currentPage == null ? 1 : this.currentPage;
    this.recordsperPage = this.recordsperPage == null ? 50 : this.recordsperPage;
    this.recordsperPage = +this.recordsperPage;
    // this.selectedWorklistId = this.commonService.getUserInfoFromLocalStorage('dashbordSelectedWorklist');
    this.selectedWorklistId = this.memorystore.getItem('dashbordSelectedWorklist');
    setTimeout(() => {
      let el: HTMLElement = this.selectedCountTd ?.nativeElement;
      el ?.click();

      this.countStickyGridWidth = this.countStickyTable.nativeElement.offsetWidth;
    }, 2000);

    if (this.backflag == true) {
      // let doc = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_doc_type_obj'));
      // let process = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_process_type_obj'));
      let doc = JSON.parse(this.memorystore.getItem('dash_doc_type_obj'));
      let process = JSON.parse(this.memorystore.getItem('dash_process_type_obj'));
      this.pageflag = true;
      this.getSummaryData(doc, process)
      this.backflag = false
    }

  }

  getApprovalQueryCount() {
    this.approvalQueryCount = 0;
    let params = new HttpParams();
    this.dataService.getData('approval-query-count', params).subscribe(res => {
      if (res != null && res.success == true) {
        this.approvalQueryCount = res.data[0].count;
      }
    });
  }

  async getProcessList() {
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('role_id', this.commonService.selectedRole);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);

    await this.dataService.getDataPromise('process', params).then(res => {
      if (res != null) {
        if (res.success == true) {
          this.ProcessList = res.data;
        }
      }
    });
  }

  async getDocumentTypes() {

    this.lstDocumentTypeFilter = [];

    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    // params = params.append('role_id', this.commonService.selectedRole);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
    params = params.append('role_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    await this.dataService.getDataPromise('document-types', params).then(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          for (var i = 0; i < res.data.length; i++) {
            this.lstDocumentTypeFilter.push({
              documentId: res.data[i].document_type_id,
              documentName: res.data[i].document_type_name,
              count: 0
            });
          }
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      })




  }

  async maxideageneratedbyUser() {
    this.maxideageneratedby = 0;
    this.totalidea = 0;
    this.ideathon_winnerfor_month = '';
    this.max_idead_generated_by_documenttype = '';
    this.total_idea_for_month = 0;
    this.winning_idea = '';

    let params = new HttpParams();
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('role_id', this.commonService.selectedRole);
    // params = params.append('userId', this.commonService.getUserInfoFromLocalStorage('userId'));
    params = params.append('userId', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    //Changed get to post
    let bodydata = {
      //  role_id:  this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole),
      //  subgroup_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup),
      projectid: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject),
      // encuserid: this.encryptDecryptservice.encryptUsingAES256(this.commonService.getUserInfoFromLocalStorage('userId'))
      encuserid: this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')),
      xusrid:this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId'))
    };
    // await this.dataService.getDataPromise('maxideageneratedbyUser', params).then(res => {
    this.dataService.postData('maxideageneratedbyUser', bodydata).subscribe(res => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data != null) {
          this.maxideageneratedby = res.data[0].max_idea_generated_by_user;
          this.totalidea = res.data[0].grand_total;
          this.ideathon_winnerfor_month = res.data[0].ideathon_winnerfor_month;
          this.ideathon_winnerfor_month = res.data[0].ideathon_winnerfor_month;
          this.max_idead_generated_by_documenttype = res.data[0].max_idead_generated_by_documenttype;
          this.total_idea_for_month = res.data[0].total_idea_for_month;
          this.winning_idea = res.data[0].winning_idea;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    }, error => {
      this.commonService.showMessageBox(error.toString());
      if (error.includes("401")) {
        this.route.navigateByUrl('/unauthorized');
        return;
      }
    })
    // err => {
    //   this.commonService.showMessageBox(err.toString());
    // });
    // }).catch(err => {
    // });




  }


  async onPageLoadFilterHistory() {
    // let dgSsearchColumns = this.commonService.getUserInfoFromLocalStorage('dashbordGridAdvanceSearchField');
    let dgSsearchColumns = this.memorystore.getItem('dashbordGridAdvanceSearchField');
    if (dgSsearchColumns != null && dgSsearchColumns != '') {
      this.advanceSearchFilterFields = JSON.parse(dgSsearchColumns);
    }

    // let dashboard_filters_string = this.commonService.getUserInfoFromLocalStorage('dashboard_filters');
    let dashboard_filters_string = this.memorystore.getItem('dashboard_filters');
    if (dashboard_filters_string != undefined && dashboard_filters_string != '') {

      let df = JSON.parse(dashboard_filters_string);
      // df = df.find(x => x.project_id == this.commonService.getUserInfoFromLocalStorage('projectId'));
      df = df.find(x => x.project_id == this.memorystore.getItem('projectId'));
      if (df != undefined && df != null) {
        if (df.filter_document != undefined && df.filter_document != '') {
          this.filteredDoctypes = df.filter_document.trim().split(',');
          this.filteredDoctypes = this.filteredDoctypes.map((i) => Number(i));
        }

        if (df.filter_queue != undefined && df.filter_queue != '') {
          this.filteredQueue = df.filter_queue.trim().split(',');
          this.filteredQueue = this.filteredQueue.map((i) => Number(i));
        }
      }
    }

    // let dashbordSelectedWorklist = this.commonService.getUserInfoFromLocalStorage('dashbordSelectedWorklist');
    let dashbordSelectedWorklist = this.memorystore.getItem('dashbordSelectedWorklist');
    if (dashbordSelectedWorklist != '' && dashbordSelectedWorklist != null) {
      this.selectedWorklistId = dashbordSelectedWorklist;
    }

    return true;
  }

  async getDashboardFilter() {

    this.isDisplayTransactionData = false;
    let searchColumns = {};

    this.advanceSearchFilterFields.forEach((field) => {
      if (field.search_value != '') {
        if (field.control_type == 'DATE') {
          searchColumns[field.db_column_name] = this.commonService.dateFormating(field.search_value);
        }
        else {
          searchColumns[field.db_column_name] = field.search_value.toString();
        }
      }
    });

    let reqData = {
      project_id: this.commonService.selectedProject,
      role_id: this.commonService.selectedRole,
      subgroup_id: this.commonService.selectedSubgroup.toString(),
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      document_type_ids: this.filteredDoctypes.toString(),
      process_queue_ids: this.filteredQueue.toString(),
      search_columns: searchColumns,
    };
    await this.dataService.postDataPromise('dashboard-filter', reqData, null).then(res => {
      if (res != null && res != undefined && res.data != null) {
        this.lstWorkListFilter = [];
        if (res.data.length > 0) {
          this.lstWorkListFilter = res.data;
          this.selectedWorklistId = this.lstWorkListFilter[0].worklist_id;
          // this.commonService.setUserInfoToLocalStorage('dashbordSelectedWorklist', this.selectedWorklistId);
          this.memorystore.setItem('dashbordSelectedWorklist', this.selectedWorklistId);
        }
        this.fillDocumentTypeFilter();
      }
    });
  }

  async getProcessData() {
    this.isDisplayTransactionData = false;
    let searchColumns = {};

    // this.advanceSearchFilterFields.forEach((field) => {
    //   if (field.search_value != '') {
    //     if (field.control_type == 'DATE') {
    //       searchColumns[field.db_column_name] = this.commonService.dateFormating(field.search_value);
    //     }
    //     else {
    //       searchColumns[field.db_column_name] = field.search_value.toString();
    //     }
    //   }
    // });

    let priority = [];
    if (this.ddlPriority != "") {
      priority.push(this.ddlPriority)
    }

    let reqData = {
      project_id: this.commonService.selectedProject,
      role_id: this.commonService.selectedRole,
      subgroup_id: this.commonService.selectedSubgroup.toString(),
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      document_type_ids: this.filteredDoctypes.toString(),
      process_queue_ids: this.filteredQueue.toString(),
      worklist_id: this.selectedWorklistId,
      search_columns: searchColumns,
      urn: this.txtURN,
      priority: priority,
      source: this.txtInputType,
      from_email: this.txtInputFrom
    };

    if (this.commonService.readInput(this.commonService.dateFormating(this.invoiceCreationDateRange.value.start_date)) != "" && this.commonService.readInput(this.commonService.dateFormating(this.invoiceCreationDateRange.value.end_date)) != "")
      reqData['date_range'] = { "start_date": this.commonService.dateFormating(this.invoiceCreationDateRange.value.start_date), "end_date": this.commonService.dateFormating(this.invoiceCreationDateRange.value.end_date) };
    if (this.selectedWorklistId != null && this.selectedWorklistId > 0) {
      await this.dataService.postDataPromise('dashboard-quick-view', reqData, null).then((res) => {
        this.lstProcessData = res.data;
        if (this.lstProcessData == undefined || this.lstProcessData == null || this.lstProcessData.length == 0) {
          //this.commonService.showMessageBox('No data found.', 'Information');
          //return;
        }

        this.fillProcessQueue();
      });
    }

  }

  fillProcessQueue() {
    //Generates the lstProcessQueue data

    this.lstProcessQueue = [];

    this.lstProcessData.forEach((x) => {
      if (this.lstProcessQueue.findIndex((a) => a.ProcessId == x.process_id) == -1) {
        let lstDoc = [];
        let processCount = 0;

        this.filteredDoctypes.forEach((d) => {
          if (d != 0) {
            let doc = x.documents.find((f) => f.document_type_id == d);
            if (doc != null && doc != undefined) {
              lstDoc.push({
                documentId: d,
                documentName: doc.document_type_name,
                count: doc.document_count,
              });
              processCount += doc.document_count;
            } else {
              let fDoc = this.lstDocumentTypeFilter.find((dl) => dl.documentId == d)
              if (fDoc != null && fDoc != undefined) {
                let doc_name = fDoc.documentName;
                lstDoc.push({
                  documentId: d.documentId,
                  documentName: doc_name,
                  count: 0,
                });
              }
            }
          }
        });

        this.lstProcessQueue.push({
          processId: x.process_id,
          processName: x.process_name,
          count: processCount,
          documentList: lstDoc,
        });
      }
    });
    //Generates document queue
    this.lstDocumentQueue = [];

    this.filteredDoctypes.forEach((d) => {
      if (d != 0) {
        let lstProc = [];
        let docCount = 0;

        this.lstProcessData.forEach((p) => {
          let doc = p.documents.find((f) => f.document_type_id == d);
          if (doc != null && doc != undefined) {
            lstProc.push({
              processId: p.process_id,
              processName: p.process_name,
              count: doc.document_count,
            });
            docCount += doc.document_count;
          } else {
            lstProc.push({
              processId: p.process_id,
              processName: p.process_name,
              count: 0,
            });
          }
        });

        let fDoc = this.lstDocumentTypeFilter.find((dl) => dl.documentId == d);
        if (fDoc != null && fDoc != undefined) {
          let doc_name = fDoc.documentName
          this.lstDocumentQueue.push({
            documentId: d,
            documentName: doc_name,
            count: docCount,
            processList: lstProc,
          });
        }

      }
    });

  }

  getTransaction(doc: any, process: any, downloadflag: boolean) {
    this.currentdoc = doc;
    this.currentprocess = process;
    //this.isDisplayTransactionData = false;

    if (downloadflag == true) {
      this.lstTransaction_download = [];
    }
    else {
      this.lstHeaders = [];
      this.lstTransaction = [];
    }


    let searchColumns = {};

    this.advanceSearchSummaryFields.forEach((field) => {
      if (field.search_value != '') {
        if (field.control_type == 'DATE') {
          field.search_value = this.commonService.dateFormating(
            field.search_value
          );
        }
        searchColumns[field.db_column_name] = field.search_value.toString();
      }
    });
    // this.commonService.setUserInfoToLocalStorage('transactionGridSearchField', JSON.stringify(this.advanceSearchSummaryFields));
    // this.commonService.setUserInfoToLocalStorage('dashbordSelectedWorklist', this.selectedWorklistId);
    this.memorystore.setItem('transactionGridSearchField', JSON.stringify(this.advanceSearchSummaryFields));
    this.memorystore.setItem('dashbordSelectedWorklist', this.selectedWorklistId);
    let parentSearchField = this.advanceSearchSummaryStaticFields;
    let priority = [];
    if (parentSearchField.Priority != "") {
      priority.push(parentSearchField.Priority)
    }


    let reqData = {
      project_id: this.commonService.selectedProject,
      role_id: this.commonService.selectedRole,
      subgroup_id: this.commonService.selectedSubgroup,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      worklist_id: this.selectedWorklistId,
      document_type_ids: this.currentdoc.documentId.toString(),
      process_id: this.currentprocess.processId,
      search_columns: searchColumns,
      urn: "",
      priority: [],
      source: "",
      from_email: "",
      date_range: null,
      currentpage: this.currentPage,
      recordsperPage: this.recordsperPage,
      downloadflag: downloadflag
    };
    if (this.commonService.readObject(parentSearchField) != null) {
      reqData.urn = parentSearchField.URN;
      if (reqData.urn != "") {
        searchColumns["d.urn"] = reqData.urn;
      }
      reqData.priority = priority;
      reqData.source = parentSearchField.SOURCE;
      reqData.from_email = parentSearchField.FROM_EMAIL;
      if (this.commonService.readInput(parentSearchField.Created_Dt_From) != "" && this.commonService.readInput(parentSearchField.Created_Dt_To) != "")
        reqData.date_range = { "start_date": parentSearchField.Created_Dt_From, "end_date": parentSearchField.Created_Dt_To };
    }

    this.dataService.postData('dashboard-details', reqData).subscribe((res) => {
      if (res != null && res != undefined && res.data != null && res.data.length > 0) {

        if (downloadflag == true) {
          if (res.data[0].table_data.length == 0) {
            this.commonService.showMessageBox('No Idea(s) found.');
            return;
          }
          else {
            this.lstTransaction_download = res.data[0].table_data;

            this.lstTransaction_download.forEach(function (x) { delete x.RowNo; delete x.TotalRecordsCount; });

            this.commonService.exportAsExcelFile(this.lstTransaction_download, 'transaction-summary');
          }
        }
        else {
          if (res.data[0].table_data.length == 0) {
            this.commonService.showMessageBox('No ideas(s) found.');
            return;
          }

          this.lstHeaders = res.data[0].table_sections;
          this.lstHeaders_log.forEach(sec => {
            sec.section_fields.forEach(f => {
              let field = this.lstHeaders.find(x => x.section_name == sec.section_name) ?.section_fields.find(y => y.name == f.name);
              if (field) {
                field.is_visible = f.is_visible;
              }
            });
          });
          this.lstTransaction = res.data[0].table_data;
          this.isDisplayTransactionData = true;

          setTimeout(() => {
            this.pageSection.nativeElement.scrollTop = this.summaryGrid.nativeElement.offsetTop;
          }, 500);
        }

      }
    });
  }

  getSearchTransaction() {  //Quick Search

    if (this.searchURN == '' || this.searchURN == null || this.searchURN == undefined) {
      this.commonService.showMessageBox('Please enter the URN to search.', 'Alert');
      return;
    }
    else if (/\W/.test(this.searchURN) == true) {
      this.commonService.showMessageBox('Please enter only alphabet, number and underscore.', 'Alert');
      return;
    }

    this.lstHeader_search = [];
    this.lstTransaction_search = [];

    let reqData = {
      project_id: this.commonService.selectedProject,
      role_id: this.commonService.selectedRole,
      subgroup_id: this.commonService.selectedSubgroup,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      worklist_id: this.selectedWorklistId,
      document_type_ids: this.filteredDoctypes.toString(),
      process_id: 0,
      search_columns: { 'd.urn': this.searchURN.toString() },
      currentpage: 1,
      recordsperPage: 50
    };
    if (this.selectedWorklistId > 0 && this.selectedWorklistId != null) {
      this.dataService.postData('dashboard-details', reqData).subscribe((res) => {
        if (res != null && res != undefined) {

          if (res.success == false) {
            this.commonService.showMessageBox('Internal Error.<br>' + res.errorMessage);
            return;
          }
          if (res.data[0].table_data.length == 0) {
            this.commonService.showMessageBox('No invoice(s) found for entered URN value.');
            return;
          }
          this.lstHeader_search = res.data[0].table_sections;
          this.lstHeaders_log.forEach(sec => {
            sec.section_fields.forEach(f => {
              let field = this.lstHeader_search.find(x => x.section_name == sec.section_name) ?.section_fields.find(y => y.name == f.name);
              if (field) {
                field.is_visible = f.is_visible;
              }
            });
          });
          this.lstTransaction_search = res.data[0].table_data;
          this.isDisplaySearchGrid = true;
        }
      });
    }
  }

  onTransactionSummaryGridCellClick(doc: any, process: any) {
    this.currentPage = 1;
    this.recordsperPage = 50;
    // this.commonService.setUserInfoToLocalStorage("transactionSummary_CurrentPage", this.currentPage);
    // this.commonService.setUserInfoToLocalStorage("transactionSummary_RecordsPerPage", this.recordsperPage);
    this.memorystore.setItem("transactionSummary_CurrentPage", this.currentPage);
    this.memorystore.setItem("transactionSummary_RecordsPerPage", this.recordsperPage);
    this.getSummaryData(doc, process)
  }

  async getSummaryData(doc: any, process: any) {
    if (doc.count == 0 || process.count == 0) {
      this.isDisplayTransactionData = false;
      return;
    }

    this.showStatDrop = false;
    this.activeProcess = process.processId;
    this.processName = process.processName;
    this.activeDocument = doc.documentId;
    this.selectedDocument = doc.documentName;
    // this.commonService.setUserInfoToLocalStorage('dash_docTypeId', this.activeDocument);
    // this.commonService.setUserInfoToLocalStorage('dash_processId', this.activeProcess);
    // this.commonService.setUserInfoToLocalStorage('dash_doc_type_obj', JSON.stringify(doc));
    // this.commonService.setUserInfoToLocalStorage('dash_process_type_obj', JSON.stringify(process));
    this.memorystore.setItem('dash_docTypeId', this.activeDocument);
    this.memorystore.setItem('dash_processId', this.activeProcess);
    this.memorystore.setItem('dash_doc_type_obj', JSON.stringify(doc));
    this.memorystore.setItem('dash_process_type_obj', JSON.stringify(process));
    await this.getAdvanceSearchFields(true);
    this.getTransaction(doc, process, false);
  }

  async getAdvanceSearchFields(isSummarySearch: boolean) {

    let reqData = {
      project_id: this.commonService.selectedProject,
      subgroup_id: this.commonService.selectedSubgroup,
      document_type_ids: isSummarySearch ? this.activeDocument.toString() : this.filteredDoctypes.toString(),
    };

    await this.dataService.getDataPromise('advanced-search-fields', reqData).then((res) => {
      if (res != null && res.data != null) {
        if (isSummarySearch) {
          this.advanceSearchSummaryFields = res.data;
          this.advanceSearchSummaryFields.forEach(async (element) => {
            element['search_value'] = '';
            if (element.control_type == 'TEXTBOX') {
              element.value_type = element.validation_type == 'NUMERIC' ? 'number' : 'text';
            }

            if (element.control_type == 'DROPDOWN') {
              element.options = await this.commonService.getDropdownData(element.field_mapping_detail_id);
              element.options.splice(0, 0, { id: 0, name: '-- Select --' });
            }
          });
          if (this.advanceSearchFilterFields.length > 0) {
            this.advanceSearchFilterFields.forEach((element) => {
              if (this.advanceSearchSummaryFields.findIndex((x) => x.db_column_name == element.db_column_name) > -1) {
                this.advanceSearchSummaryFields.find((x) => x.db_column_name == element.db_column_name).search_value = element.search_value;
              }
            });
          }
        } else {
          this.advanceSearchFilterFields = res.data;
          this.advanceSearchFilterFields.forEach(async (element) => {
            element['search_value'] = '';
            if (element.control_type == 'TEXTBOX') {
              element.value_type = element.validation_type == 'NUMERIC' ? 'number' : 'text';
            }
            if (element.control_type == 'DROPDOWN') {
              element.options = await this.commonService.getDropdownData(element.field_mapping_detail_id);
              element.options.splice(0, 0, { id: 0, name: '-- Select --' });
            }
          });
        }
      }
    });
  }

  advanceSearchClickEvent(parentSearchField: any) {

    this.advanceSearchSummaryStaticFields = parentSearchField;
    this.getTransaction(
      {
        documentId: this.activeDocument,
        documentName: this.selectedDocument,
        count: 1,
      },
      {
        processId: this.activeProcess,
        processName: this.processName,
        count: 1,
      },
      false
    );
  }

  columnsFilterChangeEvent(lstHeaders: any) {
    this.lstHeaders_log = lstHeaders;
  }

  filterTransactionGridByLocalSearch() {
    // let locStorTransactionSearchField = this.commonService.getUserInfoFromLocalStorage('transactionGridSearchField');
    let locStorTransactionSearchField = this.memorystore.getItem('transactionGridSearchField');
    if (locStorTransactionSearchField != '') {
      this.advanceSearchSummaryFields = JSON.parse(locStorTransactionSearchField);
    }
    return true;
  }

  openFilterFieldMagnifySearchModal(fieldMappingDetailId: number, magnifyDependantFields: string = null, predefinedTableColumnName: string = 'id') {

    let dependantFieldValues = {};
    if (magnifyDependantFields != null) {
      magnifyDependantFields = JSON.parse(magnifyDependantFields);
      Object.keys(magnifyDependantFields).forEach(x => {
        let field = this.advanceSearchFilterFields.find(f => f.db_column_name == magnifyDependantFields[x]);
        if (field != undefined) {
          let field_value = field.search_value;
          if (field_value != null && field_value != '' && field_value != undefined) {
            // if (field.control_type == 'DROPDOWN') {
            //   field_value = field.options.find(d => d.id == field_value).name;
            // }
            dependantFieldValues[x] = field_value.toString();
          }
        }


      });
    }

    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = fieldMappingDetailId;
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.predefinedTableColumnName = predefinedTableColumnName;
    modalRef.componentInstance.selectRecord.subscribe((res) => {
      const selectedField = this.advanceSearchFilterFields.find(x => x.field_mapping_detail_id == res.fieldId);
      //selectedField.search_value = res.fieldValue.toString();
      if (selectedField != null) {
        this.frmFilterSearch
          .get(selectedField.db_column_name)
          .setValue(res.fieldValue.toString());

        if (selectedField.control_type == 'DROPDOWN') {
          // if dependent field in advance search then add code here
        }
      }
      modalRef.close();

    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  async showFilterModel() {
    if (this.filteredQueue == undefined || this.filteredQueue.length == 0) {
      this.onSelectFilterQueue(0);
    }

    let lastAdvanceSearchFilterFields: any
    lastAdvanceSearchFilterFields = JSON.parse(JSON.stringify(this.advanceSearchFilterFields));

    await this.getAdvanceSearchFields(false);

    const formControls: any = {};
    this.advanceSearchFilterFields.forEach(async (field) => {
      let fieldValidators = [];
      let defaultValue: any = "";

      let f = lastAdvanceSearchFilterFields.find(f => f.db_column_name == field.db_column_name);
      if (f != undefined)
        defaultValue = f.search_value;
      else
        defaultValue = field.control_type == 'DATE' ? '' : field.control_type == 'DROPDOWN' ? '' : field.control_type == 'CHECKBOX' ? false : '';

      formControls[field.db_column_name] = new FormControl(defaultValue, fieldValidators);
    });

    this.frmFilterSearch = new FormGroup(formControls);

    this.showModal(this.filterOptionModal, 'lg');

  }

  async filterProcessData() {

    if (this.filteredQueue.length == 0) {
      this.commonService.showMessageBox("Please select at least one Queue.", "Message");
      return
    }

    if (this.filteredDoctypes.length == 0) {
      this.commonService.showMessageBox("Please select at least one Work Item.", "Message");
      return
    }

    this.modalReference.close();

    this.advanceSearchFilterFields.forEach(field => {
      if (this.frmFilterSearch.get(field.db_column_name).value != '') {
        field.search_value = this.frmFilterSearch.get(field.db_column_name).value;
      }
    });

    // this.commonService.setUserInfoToLocalStorage('dashbordGridAdvanceSearchField', JSON.stringify(this.advanceSearchFilterFields));
    this.memorystore.setItem('dashbordGridAdvanceSearchField', JSON.stringify(this.advanceSearchFilterFields));
    // let dashboard_filters = this.commonService.getUserInfoFromLocalStorage('dashboard_filters');
    let dashboard_filters = this.memorystore.getItem('dashboard_filters');
    if (dashboard_filters == '' || dashboard_filters == undefined) {
      dashboard_filters = [];
      dashboard_filters.push({
        filter_document: (this.filteredDoctypes != null) ? this.filteredDoctypes.toString() : '',
        filter_queue: (this.filteredQueue != null) ? this.filteredQueue.toString() : '',
        // project_id: this.commonService.getUserInfoFromLocalStorage('projectId')
        project_id: this.memorystore.getItem('projectId')
      });
    }
    else {
      dashboard_filters = JSON.parse(dashboard_filters);
      // let dfilter = dashboard_filters.find(f => f.project_id == this.commonService.getUserInfoFromLocalStorage('projectId'));
      let dfilter = dashboard_filters.find(f => f.project_id == this.memorystore.getItem('projectId'));
      if (dfilter != undefined) {
        dfilter = {
          filter_document: (this.filteredDoctypes != null) ? this.filteredDoctypes.toString() : '',
          filter_queue: (this.filteredQueue != null) ? this.filteredQueue.toString() : '',
          // project_id: this.commonService.getUserInfoFromLocalStorage('projectId')
          project_id: this.memorystore.getItem('projectId')
        }

        // let index = dashboard_filters.findIndex(f => f.project_id == this.commonService.getUserInfoFromLocalStorage('projectId'));
        let index = dashboard_filters.findIndex(f => f.project_id == this.memorystore.getItem('projectId'));
        dashboard_filters[index] = dfilter;
      }
      else {
        dashboard_filters.push({
          filter_document: (this.filteredDoctypes != null) ? this.filteredDoctypes.toString() : '',
          filter_queue: (this.filteredQueue != null) ? this.filteredQueue.toString() : '',
          // project_id: this.commonService.getUserInfoFromLocalStorage('projectId')
          project_id: this.memorystore.getItem('projectId')
        });
      }
    }

    // this.commonService.setUserInfoToLocalStorage('dashboard_filters', JSON.stringify(dashboard_filters));
    this.memorystore.setItem('dashboard_filters', JSON.stringify(dashboard_filters));
    //Save filter criteria in database 
    if (this.saveAsDefaultFilter)
      this.saveFilter(dashboard_filters);

    this.saveAsDefaultFilter = false;

    await this.getDashboardFilter();
    await this.getProcessData();
  }

  saveFilter(filters: any) {
    let reqData = {
      // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
      user_id: Number(this.memorystore.getItem('userId')),
      filters: JSON.stringify(filters)
    };

    this.dataService.postData('save-dashboard-filter', reqData).subscribe(res => {
    });
  }

  async fillDocumentTypeFilter() {

    this.lstDocumentTypeFilter.forEach(d => { d.count = 0; });

    this.lstWorkListFilter.forEach((element) => {
      element.documents.forEach((d) => {
        const doc = this.lstDocumentTypeFilter.find(element => element.documentId === d.document_type_id);
        if (doc != null) {
          doc.count += d.document_count
        }
        else {
          this.lstDocumentTypeFilter.push({
            documentId: d.document_type_id,
            documentName: d.document_name,
            count: d.document_count,
          });
        }
      });
    });
  }

  getWorklistCountByDoctype(documents: any): number {
    let count = 0;
    documents.forEach((element) => {
      if (this.filteredDoctypes.includes(element.document_type_id))
        count += element.document_count;
    });
    return count;
  }

  getAllDoctypeCount(): number {
    let count = 0;
    this.lstDocumentTypeFilter.forEach((element) => {
      count += element.count;
    });
    return count;
  }

  clearSearch() {
    if (
      this.searchURN == '' ||
      this.searchURN == null ||
      this.searchURN == undefined
    ) {
      this.isDisplaySearchGrid = false;
      this.lstHeader_search = [];
      this.lstTransaction_search = [];
    } else {
      this.getSearchTransaction();
    }
  }

  onIconSearchClick() {
    if (this.isDisplaySearchBox == false) {
      this.isDisplaySearchBox = true;
    } else {
      this.isDisplaySearchBox = false;
      this.isDisplaySearchGrid = false;
      this.lstHeader_search = [];
      this.lstTransaction_search = [];
      this.searchURN = '';
    }
  }

  async onSelectFilterDocument(doctypeId: any) {
    if (doctypeId == 0 && this.filteredDoctypes.includes(0)) {
      this.filteredDoctypes = [];

    } else if (doctypeId == 0) {
      this.filteredDoctypes = [0];
      this.lstDocumentTypeFilter.forEach((element) => {
        this.filteredDoctypes.push(element.documentId);
      });

    } else if (this.filteredDoctypes.includes(doctypeId)) {
      this.filteredDoctypes = this.filteredDoctypes.filter((d) => d != doctypeId && d != 0);

    } else if (doctypeId != -1) {
      this.filteredDoctypes.push(doctypeId);
      if (this.filteredDoctypes.length == this.lstDocumentTypeFilter.length) {
        this.filteredDoctypes.push(0);
      }
    }
    await this.getAdvanceSearchFields(false);
  }

  async onSelectFilterQueue(processId: any) {
    if (processId == 0 && this.filteredQueue.includes(0)) {
      this.filteredQueue = [];
    } else if (processId == 0 && this.filteredQueue.length == 0) {
      this.filteredQueue = [];
      this.ProcessList.filter(p => p.process_module != 'END PROCESS').forEach((p) => {
        this.filteredQueue.push(p.process_id);
      });
      //For Xerox below code should be uncommented
      //this.ProcessList.forEach((p) => {
      // this.filteredQueue.push(p.process_id);
      //});
    }
    else if (processId == 0) {
      this.filteredQueue = [];
      this.filteredQueue.push(0);
      this.ProcessList.forEach((p) => {
        this.filteredQueue.push(p.process_id);
      });
    } else if (this.filteredQueue.includes(processId)) {
      this.filteredQueue = this.filteredQueue.filter((p) => p != processId && p != 0);
    }
    else {
      this.filteredQueue.push(processId);
      if (this.filteredQueue.length == this.ProcessList.length) {
        this.filteredQueue.push(0);
      }
    }
  }

  async onSelectFilterWorkList(workListId: number) {
    debugger;
    this.selectedWorklistId = workListId;
    // this.commonService.setUserInfoToLocalStorage('dashbordSelectedWorklist', this.selectedWorklistId);
    this.memorystore.setItem('dashbordSelectedWorklist', this.selectedWorklistId);
    //this.filteredQueue = [];
    await this.getProcessData();

    // await this.getDashboardFilter();
    // await this.filterProcessData();

  }

  downloadalldata(param: any) {
    // let doc = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_doc_type_obj'));
    // let process = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_process_type_obj'));
    let doc = JSON.parse(this.memorystore.getItem('dash_doc_type_obj'));
    let process = JSON.parse(this.memorystore.getItem('dash_process_type_obj'));
    this.getTransaction(doc, process, true)


  }

  cellClickEvent(param: any) {

    if (param.columnName.toLowerCase() == 'urn') {

      // this.commonService.setUserInfoToLocalStorage('documentDetailId', param.rowData['DOCUMENT_DETAIL_ID']);
      this.memorystore.setItem('documentDetailId', param.rowData['DOCUMENT_DETAIL_ID']);
      if (param.hasOwnProperty('nextRowDataIDs') && param['nextRowDataIDs'] != null) {
        // this.commonService.setUserInfoToLocalStorage('nextDocumentDetailIDs', param.nextRowDataIDs);
        this.memorystore.setItem('nextDocumentDetailIDs', param.nextRowDataIDs);
      } else {
        // this.commonService.setUserInfoToLocalStorage('nextDocumentDetailIDs', '');
        this.memorystore.setItem('nextDocumentDetailIDs', '');
      }
      // this.commonService.setUserInfoToLocalStorage("currentpage", 'dashboard');
      this.memorystore.setItem("currentpage", 'dashboard');
      this.route.navigate(['transaction'], {
        state: { documentDetailId: param.rowData['DOCUMENT_DETAIL_ID'] },
      }).then(() => {
        //window.location.reload();
      });


    }
  }

  scrollGrid(direction: string): void {
    if (direction == 'next') {
      this.processData.nativeElement.scrollLeft += 500;
    } else {
      this.processData.nativeElement.scrollLeft -= 500;
    }
  }

  loadStatDrop(target: string, data: any, event: any = null) {
    this.stateDrop.nativeElement.style.top =
      event != null
        ? event.currentTarget.offsetTop +
        event.currentTarget.offsetHeight +
        7 +
        'px'
        : '50px';
    this.showStatDrop = true;
    this.lstStatDropProcess = { documentList: [] };
    this.lstStatDropDocument = { processList: [] };
    if (target == 'process') {
      if (this.activeProcess != data.processId) this.activeDocument = 0;
      this.activeProcess = data.processId;
      this.lstStatDropProcess = data;
    } else {
      if (this.activeDocument != data.documentId) this.activeProcess = 0;
      this.activeDocument = data.documentId;
      this.lstStatDropDocument = data;
    }
  }

  setPaginationLocalStorageEvent() {

    // this.commonService.setUserInfoToLocalStorage("transactionSummary_CurrentPage", this.gridTransactionData.currentPage);
    // this.commonService.setUserInfoToLocalStorage("transactionSummary_RecordsPerPage", this.gridTransactionData.recordsPerPage);
    this.memorystore.setItem("transactionSummary_CurrentPage", this.gridTransactionData.currentPage);
    this.memorystore.setItem("transactionSummary_RecordsPerPage", this.gridTransactionData.recordsPerPage);
    // this.currentPage = this.commonService.getUserInfoFromLocalStorage("transactionSummary_CurrentPage");
    // this.recordsperPage = this.commonService.getUserInfoFromLocalStorage("transactionSummary_RecordsPerPage");
    // let doc = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_doc_type_obj'));
    // let process = JSON.parse(this.commonService.getUserInfoFromLocalStorage('dash_process_type_obj'));
    this.currentPage = this.memorystore.getItem("transactionSummary_CurrentPage");
    this.recordsperPage = this.memorystore.getItem("transactionSummary_RecordsPerPage");
    let doc = JSON.parse(this.memorystore.getItem('dash_doc_type_obj'));
    let process = JSON.parse(this.memorystore.getItem('dash_process_type_obj'));
    this.getTransaction(doc, process, false)
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  setDecimalPlaces(value: any, decimalPlace: number, validationType: string) {
    return validationType.toLowerCase() == 'numeric' ? parseFloat(value == '' ? 0 : value).toFixed(Number(decimalPlace)) : value;
  }

  onTextChange(field: any) {
    let value = this.frmFilterSearch.get(field.db_column_name).value;
    this.frmFilterSearch.get(field.db_column_name).setValue(this.setDecimalPlaces(value, field.precision_point, field.validation_type))
  }

  hasValue(field) {
    let v = this.frmFilterSearch.get(field.db_column_name).value;
    if (v != undefined && v != null && v != '')
      return true
    else
      return false;
  }

  clearText(field) {
    this.frmFilterSearch.get(field.db_column_name).setValue('');
  }

  onInvoiceCreationDateChanges() {
    if (
      this.invoiceCreationDateRange.value.start_date != '' ||
      this.invoiceCreationDateRange.value.end_date != ''
    ) {
      this.isDateRangeHasValue = true;
    }
  }

  resetInvoiceCreationDateRange() {
    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });
    this.isDateRangeHasValue = false;
  }
}
